import { createReducer, Types as ReduxSauceTypes } from "reduxsauce";
import camelCase from "lodash/camelCase";

const createRSReducer = (types, initialState, reducer) => {
	const HANDLERS = {};

	Object.keys(types).forEach(type => {
		HANDLERS[type] = reducer[camelCase(type)];
	});

	HANDLERS[ReduxSauceTypes.DEFAULT] = (state = initialState) => ({ ...state });
	return createReducer(initialState, HANDLERS);
};

export default createRSReducer;
